// This script overrides the theme's default cart submission logic.

// --- Configuration (Verify these tags match your setup!) ---
const REQUIRED_COVER_TAG = 'cushion-cover'; 
const INSERT_PRODUCT_TAG = 'cushion-insert'; // <--- The tag for the cushion insert
const PRODUCT_FORM_SELECTOR = '.product-single__form'; // Selector for the Add to Cart form

// --- Core Utility Functions ---

// Function to check the cart contents via the Shopify AJAX API
async function checkCartForCover() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Could not fetch cart.');
    const cart = await response.json();

    // Checks for the custom line item property added in Liquid: properties[is_cover]
    const coverFound = cart.items.some(item => 
      item.properties && item.properties.is_cover === 'true'
    );
    
    return coverFound;
  } catch (error) {
    console.error('Error fetching cart:', error);
    // On error, assume success to prevent blocking all sales (fallback)
    return true; 
  }
}

// Function to check if the current product requires a cover
function requiresCoverCheck(form) {
    const productFormWrapper = form.closest('[data-product-id]');
    const productTagsAttribute = productFormWrapper ? productFormWrapper.dataset.productTags : '';
    
    // Returns true if current product tags contain 'cushion-insert'
    return productTagsAttribute.includes(INSERT_PRODUCT_TAG);
}

// Function to control the visual state of the Add to Cart button 💡 NEW FUNCTION 💡
function updateButtonVisualStatus(form, coverFound) {
    const isInsertProduct = requiresCoverCheck(form);
    const cartBtn = form.querySelector('[data-add-to-cart]');
    const cartBtnText = form.querySelector('[data-add-to-cart-text]');
    // Retrieve default text from data attribute set in Liquid, or fallback to a generic string
    const defaultText = cartBtnText ? cartBtnText.dataset.defaultText : 'Add to cart';
    
    if (!cartBtn) return;
    
    if (isInsertProduct) {
        if (!coverFound) {
            // State: Blocked
            cartBtn.classList.add('btn--disabled-by-logic');
            cartBtn.disabled = true;
            if (cartBtnText) {
                // Text is managed primarily by Liquid on load, but this handles dynamic updates
                cartBtnText.textContent = 'Required: Cushion Cover';
            }
        } else {
            // State: Allowed (Cover Found)
            cartBtn.classList.remove('btn--disabled-by-logic');
            // Only re-enable if the Liquid/Theme logic hasn't disabled it for other reasons (like Sold Out)
            if (!cartBtn.classList.contains('disabled')) {
                 cartBtn.disabled = false;
            }
            
            if (cartBtnText) {
                cartBtnText.textContent = defaultText; // Restore original text
            }
        }
    }
}


// --- Theme Override Logic (AJAX SUBMISSION INTERCEPTION) ---

if (theme && theme.AjaxProduct) {
    // 1. Get a reference to the original function we want to replace
    const originalAddItemFromForm = theme.AjaxProduct.prototype.addItemFromForm;

    // 2. Override the prototype function
    theme.AjaxProduct.prototype.addItemFromForm = function(evt, callback) {
        
        const isInsertProduct = requiresCoverCheck(this.form);

        if (isInsertProduct) {
            evt.preventDefault(); 
            
            if (this.addToCart) this.addToCart.classList.add('btn--loading');
            
            checkCartForCover().then(coverFound => {
                if (this.addToCart) this.addToCart.classList.remove('btn--loading');
                
                // Update button visual status instantly
                updateButtonVisualStatus(this.form, coverFound);

                if (coverFound) {
                    // Success: Execute the original Add to Cart logic.
                    console.log('Validation passed. Executing original addItemFromForm.');
                    originalAddItemFromForm.apply(this, [evt, callback]); 
                } else {
                    // Failure: No cover found, show alert.
                    alert('You must add an Outdoor Cushion Cover to your cart before adding the insert!');
                }
            }).catch(() => {
                 // Fallback: If the check itself failed, still allow original function to run.
                 originalAddItemFromForm.apply(this, [evt, callback]);
            });

            return false;
        } else {
            // Not an insert product, proceed with the original function.
            return originalAddItemFromForm.apply(this, [evt, callback]);
        }
    };
}


// --- Theme Override Logic (PAGE LOAD / VISUAL UPDATE) --- 💡 NEW BLOCK 💡

if (theme && theme.Product) {
    const originalProductInit = theme.Product.prototype.init;
    
    // Override the Product init function to add our visual check on page load
    theme.Product.prototype.init = function() {
        // Call the original init first
        originalProductInit.apply(this);

        // Check if this product requires a cover
        if (requiresCoverCheck(this.cache.form)) {
            // Run the initial cart check as soon as the product object is ready
            checkCartForCover().then(coverFound => {
                updateButtonVisualStatus(this.cache.form, coverFound);
            });
        }
    };
}